module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="cw-selecteur-activite-wrap input-group">\r\n    <input class="cw-selecteur-activite-input form-control" type="text" title="" placeholder="'+
((__t=(placeholder))==null?'':__t)+
'"></input>\r\n    <div class="input-group-append">\r\n        <span class="cw-selecteur-activite-button input-group-text d-none">'+
((__t=(UTILS.getSVGIcon("loupe")))==null?'':__t)+
'</span>\r\n    </div>\r\n</div>\r\n<div class="cw-selecteur-activite-multiSelection"></div>';
}
return __p;
};
